/**
 * Scroll parallax for banner media.
 *
 * Any element carrying [data-parallax] gets its --parallax-offset custom
 * property updated while it is on screen. The stylesheet decides how (and on
 * which breakpoints) that offset is applied, so a section can opt out on
 * mobile with a plain media query.
 *
 * data-parallax-intensity: travel of the media, in % of the section height.
 */
(function () {
  /* Sections load this file themselves, so it can land on the page twice */
  if (window.themeParallaxLoaded) return;
  window.themeParallaxLoaded = true;

  var SELECTOR = '[data-parallax]';
  var items = [];
  var ticking = false;
  var observer = null;
  var resizeObserver = null;

  function reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function measure(item) {
    var rect = item.container.getBoundingClientRect();

    item.top = rect.top + window.pageYOffset;
    item.height = rect.height;
    item.shift = (item.height * item.intensity) / 100;
  }

  function update() {
    ticking = false;

    var viewport = window.innerHeight;
    var scroll = window.pageYOffset;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];

      if (!item.visible || item.height === 0) continue;

      /* 0 while the section is just below the fold, 1 once it has left the top */
      var progress = (viewport + scroll - item.top) / (viewport + item.height);
      progress = Math.min(Math.max(progress, 0), 1);

      var offset = (0.5 - progress) * 2 * item.shift;
      item.el.style.setProperty('--parallax-offset', offset.toFixed(2) + 'px');
    }
  }

  function requestUpdate() {
    if (ticking) return;

    ticking = true;
    window.requestAnimationFrame(update);
  }

  function remeasure() {
    for (var i = 0; i < items.length; i++) {
      measure(items[i]);
    }

    requestUpdate();
  }

  function setup() {
    if (observer) return;

    observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var item = entries[i].target.parallaxItem;
          if (!item) continue;

          item.visible = entries[i].isIntersecting;
          if (item.visible) measure(item);
        }

        requestUpdate();
      },
      { rootMargin: '100px 0px' }
    );

    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(remeasure);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', remeasure, { passive: true });
  }

  function register(el) {
    if (el.parallaxItem || reduceMotion()) return;

    var container = el.parentElement;
    if (!container) return;

    setup();

    var item = {
      el: el,
      container: container,
      intensity: parseFloat(el.getAttribute('data-parallax-intensity')) || 0,
      visible: false,
      top: 0,
      height: 0,
      shift: 0,
    };

    el.parallaxItem = item;
    items.push(item);

    measure(item);
    observer.observe(el);
    if (resizeObserver) resizeObserver.observe(container);
  }

  function unregister(el) {
    var item = el.parallaxItem;
    if (!item || !observer) return;

    var index = items.indexOf(item);
    if (index !== -1) items.splice(index, 1);

    observer.unobserve(el);
    if (resizeObserver) resizeObserver.unobserve(item.container);

    el.style.removeProperty('--parallax-offset');
    delete el.parallaxItem;
  }

  function scan(root) {
    var elements = (root || document).querySelectorAll(SELECTOR);

    for (var i = 0; i < elements.length; i++) {
      register(elements[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  /* Theme editor re-renders a section without reloading the page */
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var elements = event.target.querySelectorAll(SELECTOR);

    for (var i = 0; i < elements.length; i++) {
      unregister(elements[i]);
    }
  });
})();
